export default "/_next/static/images/4810bc702bbf7a95bc5eefe554dcc2e4.png";